import React from 'react';
import { motion } from 'framer-motion';
export function Board() {
  const boardMembers = [{
    name: 'Brannon Hampton',
    title: 'President',
    image: 'https://www.goodyearaz.gov/home/showpublishedimage/21530/638233913082230000',
    bio: "Goodyear City Council Vice Mayor and Arizona financial advisor committed to growing the region's business community."
  }, {
    name: 'Thomas Schoaf',
    title: 'Vice President',
    image: 'https://litchfieldpark.gov/ImageRepository/Document?documentID=8738',
    bio: 'Mayor of Litchfield Park and longtime Arizona attorney with deep roots in business law and community leadership.'
  }, {
    name: 'Jennifer Polansky',
    title: 'Treasurer',
    image: 'https://www.JenniferPolansky.com/briefcase/139926_111202572910AM88789.jpg',
    bio: 'Arizona REALTOR®, entrepreneur, community builder, and Rotarian serving on the West Valley Regional Chamber Board who founded the Estrella Community Garden.'
  }, {
    name: 'Joseph Pizzillo',
    title: 'Board Member',
    image: 'https://www.goodyearaz.gov/home/showpublishedimage/728/638721164647930000',
    bio: 'Mayor of Goodyear and seasoned finance professional with 30 years of experience in government budgeting and economic development.'
  }, {
    name: 'Jodi Tas',
    title: 'Board Member',
    image: 'https://cdn.magicpatterns.com/uploads/5F1Y1u9TVh8A8FNaE387S6/pasted-image.jpg',
    bio: 'City of Surprise Government Relations Director and trusted connector between Arizona businesses and elected officials.'
  }, {
    name: 'Mike Pineda',
    title: 'Board Member',
    image: 'https://cdn.magicpatterns.com/uploads/javWwyTYw4GySrMNVUrDYt/pasted-image.jpg',
    bio: 'Mayor of Avondale, lifelong Arizona resident, and Business Program Director at Estrella Mountain Community College with a deep background in small business development and entrepreneurship.'
  }, {
    name: 'Tamara Jamison',
    title: 'Board Member',
    image: 'https://cdn.magicpatterns.com/uploads/pYoTEzGXQ7kSZQQ617hgKv/image.png',
    imagePosition: 'object-[50%_12%]',
    bio: 'CORE Construction leader who partners with Arizona cities and towns on the infrastructure and community projects that support responsible local growth.'
  }];
  return <section id="leadership" className="py-24 bg-pac-sand" data-id="element-8" data-mp="15n51buiomrvz">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-9" data-mp="15k964dy7yhb8">
        <div className="text-center mb-16" data-id="element-10" data-mp="10otsnn44infc">
          <h2 className="font-serif text-4xl md:text-5xl font-bold text-pac-navy mb-4" data-id="element-11" data-mp="wlx65lbgq764">
            Board of Directors
          </h2>
          <p className="text-xl text-slate-600 max-w-2xl mx-auto" data-id="element-12" data-mp="rnn9t7e050ix">
            Municipal and community leaders committed to Arizona&apos;s cities and towns.
          </p>
          <div className="w-24 h-1 bg-pac-red mx-auto mt-6" data-id="element-13" data-mp="3cd2zu05ecl7i" />
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8" data-id="element-14" data-mp="3cf5yt9oj1ood">
          {boardMembers.map((member, index) => <motion.article key={member.name} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: index * 0.1
        }} className="bg-white rounded-xl overflow-hidden shadow-lg border border-slate-200" data-id="element-15" data-mp="1wtvizk8hyna3" data-mpi={index}>
              <div className="aspect-[4/5] w-full overflow-hidden bg-slate-100" data-id="element-16" data-mp="2anmn2d3gleyf">
                <img src={member.image} alt={member.name} className={`w-full h-full object-cover ${member.imagePosition ?? 'object-[center_20%]'} hover:scale-105 transition-transform duration-500`} data-id="element-17" data-mp="2fis4aylx25g6" />
              </div>
              <div className="p-6 text-center" data-id="element-18" data-mp="q79gmbi1lndc">
                <h3 className="font-serif text-2xl font-bold text-pac-navy mb-1" data-id="element-19" data-mp="u70et09wf5rw">{member.name}</h3>
                <p className="text-pac-red font-bold text-sm uppercase tracking-wider mb-4" data-id="element-20" data-mp="3v27uzpmxhce8">{member.title}</p>
                <p className="text-slate-600 text-sm leading-relaxed" data-id="element-21" data-mp="3r1flcva595hf">{member.bio}</p>
              </div>
            </motion.article>)}
        </div>
      </div>
    </section>;
}